import { useContext } from 'react';

import styles from '../../ShoppingCartModal.module.scss';

import { Button, ButtonTheme, ButtonVariant } from '@base-components/Button';
import { CartContext } from '@context/cart';
import { useRedirect } from '@hooks/useRedirect';
import { Paths } from '@utils/paths/paths';

interface CustomFooterProps {
  continueShoppingText: string;
  goToCartText: string;
}

export const CustomFooter = ({ continueShoppingText, goToCartText }: CustomFooterProps) => {
  const { toggleCart } = useContext(CartContext);
  const redirect = useRedirect();

  return (
    <div className={styles.cartModalFooter}>
      <Button
        as="button"
        onClick={toggleCart}
        variant={ButtonVariant.Basic}
        isFullWidth
        theme={ButtonTheme.SoftBlue}
        dataAttribute={{ 'data-test-id': 'continue-shopping' }}
      >
        {continueShoppingText}
      </Button>
      <Button
        as="button"
        onClick={() => {
          toggleCart();
          redirect({ pageId: Paths.Cart });
        }}
        variant={ButtonVariant.Basic}
        isFullWidth
        isElevated
        dataAttribute={{ 'data-test-id': 'go-to-cart' }}
      >
        {goToCartText}
      </Button>
    </div>
  );
};
